import styled from 'styled-components';
import { blueSecondaryLink } from 'components/Globals/Base/Link/LinkStyles';
import { bulletList } from 'styles/lists';
import { breakpoint } from 'styles/globals';
import { Theme, getBodyStyle } from 'styles/theme';

export const AboutWrapper = styled.div`
  padding: 16px 0 0;

  @media(${breakpoint.mdMin}) {
    padding-top: 0;

    .about-featured {
      padding-top: 40px;
    }
  }

  .about-featured {
    padding-top: 16px;
  }

  @media(${breakpoint.lgMin}) {
    display: flex;
    padding: 0 24px;
    gap: 80px;

    .about-featured {
      padding-top: 0;
    }
  }
`;

export const DescriptionWrapper = styled.div<{ theme: Theme }>`
  ${getBodyStyle('graphikCond', { default: 'default' })};
  ${bulletList};

  a {
    ${blueSecondaryLink};
  }

  @media (${breakpoint.lgMin}) {
    max-width: 55%;
  }
`;

export const GreatPlaceWrapper = styled.div<{ theme: Theme }>`
  padding: 16px 0 0;
  position: relative;
  
  @media(${breakpoint.mdMin}) {
    padding-top: 0;
  }

  @media (${breakpoint.lgMin}) {
    .about-featured {
      padding-top: 0;
    }
  }

  .prev, .next {
    bottom: -23px;
    top: unset;
    &.slick-disabled {
      visibility: hidden;
    }
  }
`;

export const SliderWrapper = styled.div`
  .slick-slider {
    -webkit-user-select: auto;
    -khtml-user-select: auto;
    -moz-user-select: auto;
    -ms-user-select: auto;
    user-select: auto;
  }
  .slick-list.draggable {
    -webkit-user-select: auto;
    -khtml-user-select: auto;
    -moz-user-select: auto;
    -ms-user-select: auto;
    user-select: auto;
  }
`;

export const FeaturedMedia = styled.div`
  flex: 1 2 50%;
  order: 1;
  position: relative;

  @media (${breakpoint.mdMin}) {
    padding: 0 0 24px 0;
  }
  @media (${breakpoint.lgMin}) {
    order: 2;
    padding: 0 0 0 24px;
  }
  @media (${breakpoint.xxlMin}) {
    padding: 0 0 0 24px;
  }
`;

export const Credit = styled.div<{ theme: Theme }>`
  ${getBodyStyle('graphikCond', { default: 'xsmall' })};
  letter-spacing: 1.2;
  padding: 4px 0 0 16px;
  text-transform: uppercase;
  
  @media (${breakpoint.mdMin}) {
    padding: 4px 0 0;
  }
`;
